import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, TextRun, HeightRule, convertInchesToTwip, SimpleField, PageNumber, NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import "./TransformerFour.css";
import TransformerThree from "./TransformerThree";
import { API_URL } from "./API";

function TransformerFour({ formData, goBack, savedGeneralData }) {

  const [testBoxes, setTestBoxes] = useState([
    { id: 'test_0', label: '', type: 'UST' }
  ]);

  const [selectedTests, setSelectedTests] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [inspectionStatus, setInspectionStatus] = useState({
    visualInspection: 'OK',
    wiringChecking: 'OK',
    erectionChecking: 'OK',
    wtiOtiChecking: 'OK',
    breatherChecking: 'OK'
  });
  const [savedGeneralData1, setSavedGeneralData] = useState(null);
  const [testData, setTestData] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [surgeArresterValues, setSurgeArresterValues] = useState(['', '', '']);
  const [surgeArresterUnits, setSurgeArresterUnits] = useState(['MΩ', 'MΩ', 'MΩ']);

  const [showPreviousPage, setShowPreviousPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isDataCleared, setIsDataCleared] = useState(false);
  const [hasHydratedFromStorage, setHasHydratedFromStorage] = useState(false);

  const voltageOptions = ["250 KV", "500 KV", "1000 KV", "1500 KV", "2000 KV", "2500 KV", "3000 KV", "5000 KV", "10000 KV"];
  const resistanceUnits = ["TΩ", "GΩ", "MΩ", "KΩ", "Ω"];
  const testTypeOptions = ["UST", "GST", "GSTg"];
  const connectionTypes = ['R-E', 'Y-E', 'B-E'];


  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });
  const getAllTransformerLocalStorageKeys = () => {
    const allKeys = [];


    const authKeys = [
      'currentUser',
      'currentUserEmail',
      'currentUserName',
      'currentUserId',
      'currentUserProfileImage',
      'authToken',
      'currentUserRole',
      'accessLevel',
      'allEmployeesData'
    ];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        allKeys.push(key);
      }
    }

    const transformerKeys = allKeys.filter(key => {
      const lowerKey = key.toLowerCase();


      if (authKeys.includes(key)) {
        return false;
      }

      return (
        lowerKey.includes('transformer') ||
        lowerKey.includes('voltage') ||
        lowerKey.includes('excitation') ||
        lowerKey.includes('tandelta') ||
        lowerKey.includes('surge') ||
        lowerKey.includes('arrester') ||
        lowerKey.includes('inspection') ||
        lowerKey.includes('test') ||
        lowerKey.includes('report') ||
        lowerKey.includes('data') ||
        lowerKey.includes('form') ||
        lowerKey.includes('navbar') ||
        lowerKey.includes('create') ||
        lowerKey.includes('project') ||
        lowerKey.includes('electrical') ||
        lowerKey.includes('general') ||
        lowerKey.includes('ratio') ||
        lowerKey.includes('current') ||
        lowerKey.includes('measurement') ||
        lowerKey.includes('page') ||
        lowerKey.includes('two') ||
        lowerKey.includes('three') ||
        lowerKey.includes('four')
      );
    });

    return transformerKeys;
  };


  const getAllKeysToRemove = () => {
    const dynamicKeys = getAllTransformerLocalStorageKeys();

    const specificKeysToRemove = [

      'transformerInspectionData',


      'transformerElectricalTestData',
      'transformerVoltageExcitationData',
      'transformerCompleteData',
      'transformerTestFormAllData',
      'transformerTestReportPDF',
      'transformerTestReportWord',
      'transformerGeneralData',
      'transformerTestData',
      'transformerVectorGroupImages',
      'transformerFourData',


      'transformerVoltageExcitation',
      'voltageExcitationData',
      'transformerTwoData',
      'transformer2Data',
      'transformerPageTwoData',
      'transformer_voltage_excitation_data',
      'transformer-voltage-excitation-data',
      'voltage_excitation_data',
      'voltageExcitationTestData',
      'transformerTwo',
      'transformerTwoFormData',
      'transformerTwoTestData',
      'transformerSecondPageData',
      'transformerPage2Data',
      'transformerVoltageRatioData',
      'transformerExcitationCurrentData',


      'navbarData',
      'createReportData',


      'formData',
      'testFormData',
      'electricalTestData',
      'generalInspectionData',
      'surgeArresterData',
      'tandeltaData',
      'reportData',
      'projectData',


      'voltageRatioData',
      'excitationCurrentData',
      'excitationData',
      'ratioData',
      'currentData',
      'measurementData',


      'dataWasCleared',
      'clearTimestamp',


      'transformerFormData',
      'transformerAllData',
      'transformerCompleteFormData',
      'transformerFullData',
      'transformerReportData'
    ];

    const allKeys = [...new Set([...dynamicKeys, ...specificKeysToRemove])];

    return allKeys;
  };








  const getInitialState = () => ({
    selectedTests: {},
    inputValues: {},
    inspectionStatus: {
      visualInspection: 'OK',
      wiringChecking: 'OK',
      erectionChecking: 'OK',
      wtiOtiChecking: 'OK',
      breatherChecking: 'OK'
    },
    surgeArresterValues: ['', '', ''],
    surgeArresterUnits: ['MΩ', 'MΩ', 'MΩ'],
    savedGeneralData: null,
    testData: null,
    errorMessage: ""
  });

  useEffect(() => {
    const dataWasCleared = localStorage.getItem('dataWasCleared');
    const clearTimestamp = localStorage.getItem('clearTimestamp');
    const currentTime = Date.now();

    if (dataWasCleared === 'true' && clearTimestamp && (currentTime - parseInt(clearTimestamp)) < 5000) {
      setIsDataCleared(true);

      setTestBoxes([{ id: 'test_0', label: '', type: 'UST' }]);
      setSelectedTests({});
      setInputValues({});
      setInspectionStatus({
        visualInspection: 'OK',
        wiringChecking: 'OK',
        erectionChecking: 'OK',
        wtiOtiChecking: 'OK',
        breatherChecking: 'OK'
      });
      setSurgeArresterValues(['', '', '']);
      setSurgeArresterUnits(['MΩ', 'MΩ', 'MΩ']);
      setHasHydratedFromStorage(true);
      return;
    }

    if (dataWasCleared === 'true') {
      localStorage.removeItem('dataWasCleared');
      localStorage.removeItem('clearTimestamp');
    }


    try {
      const storedData = localStorage.getItem('transformerFourData');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setTestBoxes(parsedData.testBoxes || [{ id: 'test_0', label: '', type: 'UST' }]);
        setSelectedTests(parsedData.selectedTests || {});
        setInputValues(parsedData.inputValues || {});
        setInspectionStatus(parsedData.inspectionStatus || {
          visualInspection: 'OK',
          wiringChecking: 'OK',
          erectionChecking: 'OK',
          wtiOtiChecking: 'OK',
          breatherChecking: 'OK'
        });
        setSurgeArresterValues(parsedData.surgeArresterValues || ['', '', '']);
        setSurgeArresterUnits(parsedData.surgeArresterUnits || ['MΩ', 'MΩ', 'MΩ']);
        setHasHydratedFromStorage(true);
        return;
      }
    } catch (error) {

    }


    try {
      const savedElectricalTestData = localStorage.getItem('transformerElectricalTestData');
      if (savedElectricalTestData) {
        const parsedData = JSON.parse(savedElectricalTestData);
        if (parsedData.testBoxes && parsedData.testBoxes.length > 0) {
          setTestBoxes(parsedData.testBoxes);
        }
        if (parsedData.selectedTests) setSelectedTests(parsedData.selectedTests);
        if (parsedData.inputValues) setInputValues(parsedData.inputValues);
        if (parsedData.inspectionStatus) setInspectionStatus(parsedData.inspectionStatus);
        if (parsedData.surgeArresterValues) setSurgeArresterValues(parsedData.surgeArresterValues);
        if (parsedData.surgeArresterUnits) setSurgeArresterUnits(parsedData.surgeArresterUnits);
      }
    } catch (error) {

    } finally {
      setHasHydratedFromStorage(true);
    }
  }, []);


  useEffect(() => {
    if (!hasHydratedFromStorage) return;
    const dataToSave = {
      testBoxes,
      selectedTests,
      inputValues,
      inspectionStatus,
      surgeArresterValues,
      surgeArresterUnits,
    };
    localStorage.setItem('transformerFourData', JSON.stringify(dataToSave));
  }, [testBoxes, selectedTests, inputValues, inspectionStatus, surgeArresterValues, surgeArresterUnits, hasHydratedFromStorage]);







  const addTestBox = () => {
    if (isDataCleared) return;

    const newId = `test_${Date.now()}`;
    setTestBoxes([...testBoxes, { id: newId, label: '', type: 'UST' }]);
  };


  const removeTestBox = (id) => {
    if (isDataCleared || testBoxes.length <= 1) return;

    setTestBoxes(testBoxes.filter(box => box.id !== id));

    const newSelectedTests = { ...selectedTests };
    delete newSelectedTests[id];
    setSelectedTests(newSelectedTests);

    const newInputValues = { ...inputValues };
    delete newInputValues[id];
    setInputValues(newInputValues);
  };





  const clearAllData = () => {
    try {
      const authKeys = [
        'currentUser',
        'currentUserEmail',
        'currentUserName',
        'currentUserId',
        'currentUserProfileImage',
        'authToken',
        'currentUserRole',
        'accessLevel',
        'allEmployeesData'
      ];

      const transformerKeys = getAllTransformerLocalStorageKeys();

      const specificKeysToRemove = [

        'transformerInspectionData',


        'transformerFormData',
        'transformerVoltageExcitationData',
        'transformerMagneticBalanceData',
        'transformerElectricalTestData',
        'transformerCompleteData',
        'transformerTestFormAllData',
        'transformerTestReportPDF',
        'transformerTestReportWord',
        'transformerGeneralData',
        'transformerTestData',
        'transformerVectorGroupImages',
        'transformerFourData',


        'transformerVoltageExcitation',
        'voltageExcitationData',
        'transformerTwoData',
        'transformer2Data',
        'transformerPageTwoData',
        'transformer_voltage_excitation_data',
        'transformer-voltage-excitation-data',
        'voltage_excitation_data',
        'voltageExcitationTestData',
        'transformerTwo',
        'transformerTwoFormData',
        'transformerTwoTestData',
        'transformerSecondPageData',
        'transformerPage2Data',
        'transformerVoltageRatioData',
        'transformerExcitationCurrentData',


        'navbarData',
        'createReportData',


        'formData',
        'testFormData',
        'electricalTestData',
        'generalInspectionData',
        'surgeArresterData',
        'tandeltaData',
        'reportData',
        'projectData',


        'voltageRatioData',
        'excitationCurrentData',
        'excitationData',
        'ratioData',
        'currentData',
        'measurementData',


        'transformerAllData',
        'transformerCompleteFormData',
        'transformerFullData',
        'transformerReportData'
      ];

      const allKeysToRemove = [...new Set([...transformerKeys, ...specificKeysToRemove])];




      allKeysToRemove.forEach(key => {
        if (!authKeys.includes(key)) {
          localStorage.removeItem(key);

        }
      });


      localStorage.setItem('dataWasCleared', 'true');
      localStorage.setItem('clearTimestamp', Date.now().toString());


      setTestBoxes([{ id: 'test_0', label: '', type: 'UST' }]);
      setSelectedTests({});
      setInputValues({});
      setInspectionStatus({
        visualInspection: 'OK',
        wiringChecking: 'OK',
        erectionChecking: 'OK',
        wtiOtiChecking: 'OK',
        breatherChecking: 'OK'
      });
      setSavedGeneralData(null);
      setTestData(null);
      setSurgeArresterValues(['', '', '']);
      setSurgeArresterUnits(['MΩ', 'MΩ', 'MΩ']);
      setErrorMessage("");
      setIsDataCleared(true);


      return true;
    } catch (error) {

      return false;
    }
  };




  useEffect(() => {
    return () => {

      const wasCleared = localStorage.getItem('dataWasCleared');
      if (wasCleared === 'true') {

        localStorage.removeItem('transformerVoltageExcitationData');
      }
    };
  }, []);

  const updateTestBoxLabel = (id, label) => {
    if (isDataCleared) return;

    setTestBoxes(testBoxes.map(box =>
      box.id === id ? { ...box, label } : box
    ));
  };


  const updateTestBoxType = (id, type) => {
    if (isDataCleared) return;

    setTestBoxes(testBoxes.map(box =>
      box.id === id ? { ...box, type } : box
    ));
  };

  const handleTestSelection = (testId) => {
    if (isDataCleared) return;

    setSelectedTests(prev => {
      const newSelected = { ...prev };
      newSelected[testId] = !newSelected[testId];

      if (newSelected[testId] && !inputValues[testId]) {
        setInputValues(prev => ({
          ...prev,
          [testId]: Array(3).fill().map(() => Array(4).fill(''))
        }));
      }

      return newSelected;
    });
  };

  const handleInputChange = (testId, row, col, value) => {
    if (isDataCleared) return;

    setInputValues(prev => {
      const newValues = { ...prev };

      if (!newValues[testId]) {
        newValues[testId] = Array(3).fill().map(() => Array(4).fill(''));
      }

      newValues[testId] = [...newValues[testId]];
      newValues[testId][row] = [...newValues[testId][row]];
      newValues[testId][row][col] = value;

      return newValues;
    });
  };

  const handleVoltageChange = (testId, row, value) => {
    handleInputChange(testId, row, 0, value);
  };


  const handleSurgeArresterChange = (index, value) => {
    if (isDataCleared) return;


    const newValues = [...surgeArresterValues];
    newValues[index] = value;
    setSurgeArresterValues(newValues);
  };

  const handleSurgeArresterUnitChange = (index, value) => {
    if (isDataCleared) return;


    const newUnits = [...surgeArresterUnits];
    newUnits[index] = value;
    setSurgeArresterUnits(newUnits);
  };

  const handleInspectionChange = (key, value) => {
    if (isDataCleared) return;


    setInspectionStatus(prev => ({
      ...prev,
      [key]: value
    }));
  };



  const getTestValues = (testId) => {
    if (isDataCleared || !inputValues[testId]) {
      return Array(3).fill().map(() => Array(4).fill(''));
    }
    return inputValues[testId];
  };

  const handleBack = () => {

    if (!isDataCleared) {
      const electricalTestData = {
        selectedTests,
        inputValues,
        inspectionStatus,
        surgeArresterValues,
        surgeArresterUnits
      };
      localStorage.setItem('transformerElectricalTestData', JSON.stringify(electricalTestData));
    }

    if (goBack) {
      goBack();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setIsLoading(true);
    setErrorMessage("");

    try {
      const loadFormDataSafely = (key, defaultValue = {}) => {
        try {
          const data = localStorage.getItem(key);
          return data ? JSON.parse(data) : defaultValue;
        } catch (error) {

          return defaultValue;
        }
      };

      const loadAllFormDataFromStorage = () => {
        return {
          transformerFormData: loadFormDataSafely('transformerFormData', {}),
          transformerVoltageExcitationData: loadFormDataSafely('transformerVoltageExcitationData', {}),
          transformerMagneticBalanceData: loadFormDataSafely('transformerMagneticBalanceData', {}),
          transformerElectricalTestData: loadFormDataSafely('transformerElectricalTestData', {}),
          transformerVectorGroupImages: loadFormDataSafely('transformerVectorGroupImages', {}),
          navbarData: loadFormDataSafely('navbarData', {}),
          createReportData: loadFormDataSafely('createReportData', {})
        };
      };

      const convertArrayToDict = (arr, keyPrefix = 'item') => {
        if (!Array.isArray(arr)) return arr;

        const dict = {};
        arr.forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            Object.keys(item).forEach(key => {
              dict[`${keyPrefix}_${index}_${key}`] = item[key];
            });
          } else {
            dict[`${keyPrefix}_${index}`] = item;
          }
        });
        return dict;
      };

      const convertAllArraysToDict = (obj, parentKey = '') => {
        if (Array.isArray(obj)) {
          return convertArrayToDict(obj, parentKey || 'item');
        }

        if (typeof obj === 'object' && obj !== null) {
          const converted = {};
          Object.keys(obj).forEach(key => {
            const fullKey = parentKey ? `${parentKey}_${key}` : key;
            converted[key] = convertAllArraysToDict(obj[key], fullKey);
          });
          return converted;
        }

        return obj;
      };

      const electricalTestData = {
        testBoxes, 
        selectedTests,
        inputValues,
        inspectionStatus,
        surgeArresterValues,
        surgeArresterUnits
      };

      localStorage.setItem('transformerElectricalTestData', JSON.stringify(electricalTestData));

      const allFormData = loadAllFormDataFromStorage();


      const createReportData = loadFormDataSafely('createReportData', {});


      const safeFormData = formData && typeof formData === 'object' ? {
        transformerFormData: formData.transformerFormData || allFormData.transformerFormData,
        transformerVoltageExcitationData: formData.transformerVoltageExcitationData || allFormData.transformerVoltageExcitationData,
        transformerMagneticBalanceData: formData.transformerMagneticBalanceData || allFormData.transformerMagneticBalanceData,
        transformerElectricalTestData: electricalTestData || allFormData.transformerElectricalTestData,
        transformerVectorGroupImages: formData.transformerVectorGroupImages || allFormData.transformerVectorGroupImages,
        navbarData: formData.navbarData || allFormData.navbarData
      } : allFormData;



      const wordBlob = await generateWordBlob(safeFormData);

      const reader = new FileReader();
      reader.readAsDataURL(wordBlob);

      reader.onloadend = async () => {
        try {
          const base64data = reader.result;
          localStorage.setItem('transformerTestReportWord', base64data);

          const currentDate = new Date().toISOString().split('T')[0];
          const formLocation = safeFormData.transformerFormData?.location ||
            safeFormData.navbarData?.location ||
            createReportData.location || "";

          const getProjectId = () => {


            if (createReportData?.project_id) {
              const id = parseInt(createReportData.project_id);
              if (!isNaN(id) && id > 0) {

                return id;
              }
            }


            if (projectDetails?.projectId) {
              const id = parseInt(projectDetails.projectId);
              if (!isNaN(id) && id > 0) {

                return id;
              }
            }


            if (formData?.project_id) {
              const id = parseInt(formData.project_id);
              if (!isNaN(id) && id > 0) {

                return id;
              }
            }


            if (safeFormData.transformerFormData?.project_id) {
              const id = parseInt(safeFormData.transformerFormData.project_id);
              if (!isNaN(id) && id > 0) {

                return id;
              }
            }


            throw new Error("Unable to determine project ID. Please select a project before submitting.");
          };

          const projectId = getProjectId();


          const convertedTestData = {
            transformerFormData: convertAllArraysToDict(safeFormData.transformerFormData || {}, 'transformerForm'),
            transformerVoltageExcitationData: convertAllArraysToDict(safeFormData.transformerVoltageExcitationData || {}, 'voltageExcitation'),
            transformerMagneticBalanceData: convertAllArraysToDict(safeFormData.transformerMagneticBalanceData || {}, 'magneticBalance'),
            transformerElectricalTestData: convertAllArraysToDict(safeFormData.transformerElectricalTestData || {}, 'electricalTest'),
            transformerVectorGroupImages: convertAllArraysToDict(safeFormData.transformerVectorGroupImages || {}, 'vectorGroupImages')
          };


          const subProjectName = createReportData.sub_project_name ||
            createReportData.block_no ||
            projectDetails.subProjectName ||
            "Project";



          const apiRequestData = {
            equipment_name: String(createReportData.equipment_name ||
              projectDetails.equipmentName ||
              safeFormData.transformerFormData?.equipment ||
              "Transformer"),
            test_date: String(safeFormData.transformerFormData?.formData?.date ||
              safeFormData.transformerFormData?.date ||
              createReportData.test_date ||
              currentDate),
            category_name: String(createReportData.category_name ||
              projectDetails.categoryName ||
              "Transformer"),
            subcategory_name: String(createReportData.subcategory_name ||
              projectDetails.subcategoryName ||
              "Electrical Test"),
            sub_project_name: String(subProjectName),
            project_id: projectId,
            location: String(formLocation || projectDetails.location || ""),
            report_file: {
              report_word: base64data,
              filename: `Transformer_Test_Report_${Date.now()}.docx`,
              file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },
            test_data: convertedTestData
          };



          const response = await fetch(`${API_URL}/test_report/create_test_report`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(apiRequestData),
            mode: 'cors',
            credentials: 'same-origin',
          });

          if (!response.ok) {
            let errorData;
            try {
              errorData = await response.json();

            } catch (jsonError) {

              errorData = { message: response.statusText };
            }

            throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
          }

          const result = await response.json();


          if (result.report_id || result.id) {
            const reportId = result.report_id || result.id;

            const transformerFormData = JSON.parse(localStorage.getItem('transformerFormData') || '{}');
            transformerFormData.reportNo = reportId;
            localStorage.setItem('transformerFormData', JSON.stringify(transformerFormData));


          }

          alert("Data submitted successfully");

        } catch (error) {

          setErrorMessage(`Error: ${error.message}`);
          alert(`Error saving data: ${error.message}`);
        } finally {
          setIsLoading(false);
        }
      };

    } catch (error) {


      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running.");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else if (error.message.includes("generateWordBlob is not defined")) {
        setErrorMessage("Word document generation function is missing. Please check your imports.");
        alert("Word document generation function is missing. Please check your imports.");
      } else {
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      }
      setIsLoading(false);
    }
  };


  const generateWordBlob = () => {
    return new Promise((resolve, reject) => {
      try {

        const storedFormData = JSON.parse(localStorage.getItem('transformerFormData') || '{}');
        const transformerData = JSON.parse(localStorage.getItem('transformerVoltageExcitationData') || '{}');
        const magneticBalanceData = JSON.parse(localStorage.getItem('transformerMagneticBalanceData') || '{}');
        const testFormData = JSON.parse(localStorage.getItem('transformerElectricalTestData') || '{}');
        const vectorImagesData = JSON.parse(localStorage.getItem('transformerVectorGroupImages') || '{}');


        const tableBorders = {
          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
        };


        function findValue(data, searchTerms, defaultValue = "N/A") {
          if (!data || typeof data !== 'object') return defaultValue;

          const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];

          for (let term of terms) {
            if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
              return data[term];
            }
          }

          const dataKeys = Object.keys(data);
          for (let term of terms) {
            const termLower = term.toLowerCase();
            for (let key of dataKeys) {
              if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
                return data[key];
              }
            }
          }

          for (let term of terms) {
            const termLower = term.toLowerCase();
            for (let key of dataKeys) {
              if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
                return data[key];
              }
            }
          }

          return defaultValue;
        }

        function safeToString(value) {
          if (value === null || value === undefined || value === '' || value === 'N/A') {
            return "";
          }
          return value.toString();
        }


        const fetchImageAsBase64 = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                const base64 = dataURL.split(',')[1];
                resolve(base64);
              } catch (error) {

                resolve(null);
              }
            };
            img.onerror = function () {

              resolve(null);
            };
            img.src = url;
          });
        };

        const createLightWatermark = (base64Data) => {
          return new Promise((resolve) => {
            if (!base64Data) {
              resolve(null);
              return;
            }

            try {
              const img = new Image();
              img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.globalAlpha = 0.15;

                ctx.drawImage(img, 0, 0);

                const lightDataURL = canvas.toDataURL('image/png');
                const lightBase64 = lightDataURL.split(',')[1];
                resolve(lightBase64);
              };
              img.onerror = function () {
                resolve(null);
              };
              img.src = 'data:image/png;base64,' + base64Data;
            } catch (error) {

              resolve(null);
            }
          });
        };

        const documentSections = [];

        const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
        const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";

        const vectorGroupImageUrls = [
          "https://i.ibb.co/9946JPPs/Screenshot-2025-05-24-121621.jpg",
          "https://i.ibb.co/XZJbwsB0/image.png",
          "https://i.ibb.co/ZRJW5wLP/image.png"
        ];


        Promise.all([
          fetchImageAsBase64(logoUrl),
          fetchImageAsBase64(watermarkUrl),
          ...vectorGroupImageUrls.map(url => fetchImageAsBase64(url))
        ]).then(([logoBase64, watermarkBase64, ...vectorGroupImagesBase64]) => {

          createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {


            const headerElements = [];

            if (logoBase64) {
              headerElements.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: logoBase64,
                                  transformation: {
                                    width: 80,
                                    height: 80
                                  }
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                            })
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 20, type: WidthType.PERCENTAGE },
                          margins: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "PIE POWER PRIVATE LIMITED",
                                  font: "Times New Roman",
                                  color: "#1e402c",
                                  bold: true,
                                  size: 36
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 80, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ]
                })
              );
            } else {

              headerElements.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "PIE POWER PRIVATE LIMITED",
                      font: "Times New Roman",
                      color: "#1e402c",
                      bold: true,
                      size: 36
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                      font: "helvetica",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                      font: "helvetica",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                })
              );
            }

            headerElements.push(new Paragraph({ text: "" }));
            documentSections.push(...headerElements);





            let formData;
            if (storedFormData.formData) {

              formData = storedFormData.formData;

            } else if (storedFormData.date || storedFormData.project || storedFormData.customer) {

              formData = storedFormData;

            } else if (transformerData?.formData) {

              formData = transformerData.formData;

            } else {

              formData = {};

            }




            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TRANSFORMERS INSPECTION / TEST REPORT", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Date", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.date), font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Project", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.project), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Report No", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.reportNo), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Customer", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.customer), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Client", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.client), font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: " ", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));




            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Location: ",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  }),
                  new TextRun({
                    text: safeToString(formData?.location),
                    font: "Courier New",
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "NAMEPLATE DETAILS",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [

                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Make", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.make), font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "%Impedance voltage@ 75 Deg C", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.impedanceVoltage), font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TEMP. RISE OIL", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.tempRiseOil), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TEMP. RISE WINDING", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.tempRiseWinding), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Specification", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.specification), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Frequency", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.frequency || '50') + " Hz", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "KVA", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.kva), font: "Courier New" })] })],
                        borders: tableBorders
                      }),

                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Serial Number", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.serialNo), font: "Courier New" })] })],
                        borders: tableBorders
                      })

                    ]
                  }),



                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "H.V. VOLTS", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.hvVolts), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "H.V. CURRENT", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.hvCurrent), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "L.V. VOLTS", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.lvVolts), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "L.V. CURRENT", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.lvCurrent), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),



                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase and Connection", font: "Courier New", bold: true })], spacing: { after: 100 } }), new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "HV", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.phaseConnectionHV), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Type of cooling", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.typeOfCooling), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase and Connection", font: "Courier New", bold: true })], spacing: { after: 100 } }), new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "LV", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.phaseConnectionLV), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Year of Manufacturing", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.yom), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),


                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Winding Material", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.windingMaterial), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "No. of phase", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(formData?.noOfPhase), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),




                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Vector Group", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "d3d3d3" }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({
                            text: `${safeToString(formData?.vectorGroup)}${formData?.normalVectorGroup ? ' ' + safeToString(formData?.normalVectorGroup) : ''}`,
                            font: "Courier New"
                          })]
                        })],
                        borders: tableBorders,
                        columnSpan: 3
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(new Paragraph({ text: "" }));



            const ctData = storedFormData.ctData || [];
            const hasCtData = ctData && ctData.length > 0 && ctData.some(item =>
              item.currentRatio || item.accClass || item.burden || item.imagAtVk || item.rct || item.vkMin
            );

            if (hasCtData) {
              const transformerTableRows = [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Location", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 14, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Current Ratio", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 14, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Acc. Class", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 14, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "BURDEN", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 14, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Imag.AT Vk /2", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "RCT (Ohm)", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Vk min", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 14, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ];


              const locationsWithData = ctData.filter((item) => {
                return item.currentRatio || item.accClass || item.burden ||
                  item.imagAtVk || item.rct || item.vkMin;
              });


              locationsWithData.forEach((locationData) => {
                transformerTableRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: locationData.location || "", font: "Courier New", bold: true })]
                        })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        width: { size: 14, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.currentRatio || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 14, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.accClass || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 14, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.burden || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 14, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.imagAtVk || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.rct || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [new TextRun({ text: safeToString(locationData.vkMin || ""), font: "Courier New" })]
                        })],
                        borders: tableBorders,
                        width: { size: 14, type: WidthType.PERCENTAGE }
                      })
                    ]
                  })
                );
              });

              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: transformerTableRows
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }




            const tapChangerRows = storedFormData.tapChangerData || storedFormData.rows || transformerData?.rows || [];


            const tapChangerTableRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "SWITCH POS.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "d3d3d3" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CONN", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "d3d3d3" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "HV VOLT ACROSS(V)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "d3d3d3" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "HV LINE", font: "Courier New", bold: true })], spacing: { after: 100 } }), new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CURRENT(A)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "d3d3d3" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "LV VOLT ACROSS", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "d3d3d3" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            if (tapChangerRows && tapChangerRows.length > 0) {

              const lvVoltAcrossValue = formData?.lvVoltAcross ||
                storedFormData?.formData?.lvVoltAcross ||
                storedFormData?.lvVoltAcross || '';

              tapChangerRows.forEach((row, index) => {
                const cells = [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(row.switchPos || `Tap ${index + 1}`), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(row.conn || row.connection), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(row.hvVoltAcross || row.hvVoltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(row.hvLineCurrent || row.hvCurrent), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ];


                if (index === 0) {
                  cells.push(
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(lvVoltAcrossValue), font: "Courier New" })] })],
                      borders: tableBorders,
                      rowSpan: tapChangerRows.length,
                      verticalAlign: VerticalAlign.CENTER
                    })
                  );
                }

                tapChangerTableRows.push(
                  new TableRow({
                    children: cells
                  })
                );
              });
            }




            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: tapChangerTableRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));
            documentSections.push(new Paragraph({ text: "" }));
            documentSections.push(new Paragraph({ text: "" }));




            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "VOLTAGE RATIO TEST",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));

            const voltageRatioData = transformerData?.voltageRatioData || [];
            const numberOfLvWindings = transformerData?.numberOfLvWindings || 1;

            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Applied Voltage in HV (V)",
                    font: "Courier New",
                    bold: true,
                    size: 20
                  })
                ]
              })
            );

            const appliedVoltageRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TAP NO.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-1V", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 14, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-1W", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 14, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-1U", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 14, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-N", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 14, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-N", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 14, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-N", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];


            voltageRatioData.forEach((tap, index) => {
              appliedVoltageRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.tapNo), font: "Courier New" })] })],
                      borders: tableBorders,

                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.uv), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.vw), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.wu), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.un), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.vn), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedHv?.wn), font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: appliedVoltageRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));

            for (let lvNumber = 1; lvNumber <= numberOfLvWindings; lvNumber++) {
              const lvKey = `measuredLv${lvNumber}`;
              const windingPrefix = lvNumber + 1;

              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `Measured Voltage in LV ${lvNumber} (V)`,
                      font: "Courier New",
                      bold: true,
                      size: 20
                    })
                  ]
                })
              );

              const lvHeaderRows = [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TAP", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      },
                      width: { size: 10, type: WidthType.PERCENTAGE },
                      rowSpan: 2
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}U-${windingPrefix}V`, font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      },
                      columnSpan: 3,
                      width: { size: 30, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}V-${windingPrefix}W`, font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      columnSpan: 3,
                      shading: {
                        fill: "a6a6a6"
                      },
                      width: { size: 30, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}W-${windingPrefix}U`, font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      columnSpan: 3,
                      shading: {
                        fill: "a6a6a6"
                      },
                      width: { size: 30, type: WidthType.PERCENTAGE }
                    })
                  ]
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ACTUAL", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "MEAS.", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ERROR%", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ACTUAL", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "MEAS.", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ERROR%", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ACTUAL", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "MEAS.", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ERROR%", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
                        fill: "a6a6a6"
                      }
                    })
                  ]
                })
              ];


              voltageRatioData.forEach((tap, index) => {
                lvHeaderRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.tapNo), font: "Courier New" })] })],
                        borders: tableBorders,

                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.uv?.actual), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.uv?.measured), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.uv?.error), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.vw?.actual), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.vw?.measured), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.vw?.error), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.wu?.actual), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.wu?.measured), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap[lvKey]?.wu?.error), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                );
              });


              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: lvHeaderRows
                })
              );



              documentSections.push(new Paragraph({ text: "" }));
            }



            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "EXCITATION CURRENT TEST",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            const excitationData = transformerData?.excitationData || [];


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Applied Voltage in HV (V)",
                    font: "Courier New",
                    bold: true,
                    size: 20
                  })
                ]
              })
            );

            const excitationVoltageRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TAP POS.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-1V", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-1W", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-1U", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];


            excitationData.forEach((tap, index) => {
              excitationVoltageRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.tapPos), font: "Courier New" })] })],
                      borders: tableBorders,

                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedVoltage?.uv), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedVoltage?.vw), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.appliedVoltage?.wu), font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: excitationVoltageRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));

            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Measured Current in HV (mA)",
                    font: "Courier New",
                    bold: true,
                    size: 20
                  })
                ]
              })
            );

            const excitationCurrentRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TAP POS.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U (mA)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V (mA)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W (mA)", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
                      fill: "a6a6a6"
                    },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];


            excitationData.forEach((tap, index) => {
              excitationCurrentRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.tapPos), font: "Courier New" })] })],
                      borders: tableBorders,

                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.measuredCurrent?.u), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.measuredCurrent?.v), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(tap.measuredCurrent?.w), font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: excitationCurrentRows
              })
            );




            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "VECTOR GROUP TEST",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));




            const vectorGroupRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Test Type", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Formula/Condition", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 60, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Result", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];


            const lv1Tests = [
              { type: "LV1", formula: "V1U2w + V2w1N = V1U1N", result: magneticBalanceData.vectorGroupTest?.test1 || 'N/A' },
              { type: "", formula: "V1W2v > V1V2v", result: magneticBalanceData.vectorGroupTest?.test2 || 'N/A' },
              { type: "", formula: "V1W2w = V1V2w", result: magneticBalanceData.vectorGroupTest?.test3 || 'N/A' }
            ];

            lv1Tests.forEach((test) => {
              vectorGroupRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.type, font: "Courier New" })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.formula, font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.result, font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });


            const selectedLvType = magneticBalanceData.lvType || 'LV2';
            let selectedLvTests = [];

            if (selectedLvType === 'LV2') {
              selectedLvTests = [
                { type: "LV2", formula: "V1U2W + V2W1V = V1U1V", result: magneticBalanceData.vectorGroupTest?.lv2test1 || 'N/A' },
                { type: "", formula: "V1W2W = V1V2W", result: magneticBalanceData.vectorGroupTest?.lv2test2 || 'N/A' },
                { type: "", formula: "V1W2V > V1V2V", result: magneticBalanceData.vectorGroupTest?.lv2test3 || 'N/A' }
              ];
            } else if (selectedLvType === 'LV3') {
              selectedLvTests = [
                { type: "LV3", formula: "V1U3W + V3W1V = V1U1V", result: magneticBalanceData.vectorGroupTest?.lv3test1 || 'N/A' },
                { type: "", formula: "V1W3W = V1V3W", result: magneticBalanceData.vectorGroupTest?.lv3test2 || 'N/A' },
                { type: "", formula: "V1W3V > V1V3V", result: magneticBalanceData.vectorGroupTest?.lv3test3 || 'N/A' }
              ];
            } else if (selectedLvType === 'LV4') {
              selectedLvTests = [
                { type: "LV4", formula: "V1U4W + V4W1V = V1U1V", result: magneticBalanceData.vectorGroupTest?.lv4test1 || 'N/A' },
                { type: "", formula: "V1W4W = V1V4W", result: magneticBalanceData.vectorGroupTest?.lv4test2 || 'N/A' },
                { type: "", formula: "V1W4V > V1V4V", result: magneticBalanceData.vectorGroupTest?.lv4test3 || 'N/A' }
              ];
            }

            selectedLvTests.forEach((test) => {
              vectorGroupRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.type, font: "Courier New" })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.formula, font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: test.result, font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });

            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: vectorGroupRows
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "VECTOR GROUP TEST IMAGES",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  })
                ]
              })
            )


            const processVectorGroupImages = async () => {
              try {

                const imageUrls = [
                  vectorImagesData?.image1 || "https://i.ibb.co/9946JPPs/Screenshot-2025-05-24-121621.jpg",
                  vectorImagesData?.image2 || "https://i.ibb.co/XZJbwsB0/image.png",
                  vectorImagesData?.image3 || "https://i.ibb.co/ZRJW5wLP/image.png"
                ];


                const imagePromises = imageUrls.map(url => {
                  if (url && url.trim()) {
                    return fetchImageAsBase64(url);
                  }
                  return Promise.resolve(null);
                });

                const imageBase64Array = await Promise.all(imagePromises);


                const imageTableRows = [];


                const imageCells = [];

                imageBase64Array.forEach((imageBase64, index) => {
                  if (imageBase64) {
                    imageCells.push(
                      new TableCell({
                        children: [
                          new Paragraph({
                            children: [
                              new ImageRun({
                                data: imageBase64,
                                transformation: {
                                  width: 200,
                                  height: 150
                                }
                              })
                            ],
                            alignment: AlignmentType.CENTER
                          }),
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: `Vector Group Image ${index + 1}`,
                                font: "Courier New",
                                size: 16,
                                bold: true
                              })
                            ],
                            alignment: AlignmentType.CENTER
                          })
                        ],
                        borders: tableBorders,
                        width: { size: 33.33, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER
                      })
                    );
                  } else {

                    imageCells.push(
                      new TableCell({
                        children: [
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: `Vector Group Image ${index + 1}\n(Image not available)`,
                                font: "Courier New",
                                size: 16
                              })
                            ],
                            alignment: AlignmentType.CENTER
                          })
                        ],
                        borders: tableBorders,
                        width: { size: 33.33, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER
                      })
                    );
                  }
                });

                if (imageCells.length > 0) {
                  imageTableRows.push(
                    new TableRow({
                      children: imageCells
                    })
                  );

                  documentSections.push(
                    new Table({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                      rows: imageTableRows
                    })
                  );
                }

                documentSections.push(new Paragraph({ text: "" }));


                documentSections.push(new Paragraph({ text: "" }));


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "MAGNETIC BALANCE TEST",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                const magneticBalanceTaps = magneticBalanceData.magneticBalanceTaps || 1;
                const magneticBalanceLVs = magneticBalanceData.magneticBalanceLVs || 1;

                for (let testIndex = 0; testIndex < magneticBalanceTaps; testIndex++) {

                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `Tap - ${testIndex + 1}`,
                          font: "Courier New",
                          bold: true,
                          size: 20
                        })
                      ]
                    })
                  );
                  documentSections.push(new Paragraph({ text: "" }));


                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Applied Voltage in HV (V)",
                          font: "Courier New",
                          bold: true,
                          size: 18
                        })
                      ]
                    })
                  );

                  const hvConditionRows = [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "HV CONDITION", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 20, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-1V", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 13, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-1W", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 13, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-1U", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 13, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-1N", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 13, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-1N", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 13, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-1N", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 15, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ];

                  const hvData = magneticBalanceData.magneticBalanceData?.hv?.[testIndex] || {};
                  const hvConditions = ['1U-1N', '1V-1N', '1W-1N'];

                  hvConditions.forEach((condition) => {
                    const values = hvData[condition] || Array(6).fill('');
                    const cells = [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: condition, font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" }
                      })
                    ];

                    for (let i = 0; i < 6; i++) {
                      cells.push(
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(values[i] || ''), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      );
                    }

                    hvConditionRows.push(
                      new TableRow({
                        children: cells
                      })
                    );
                  });

                  documentSections.push(
                    new Table({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                      rows: hvConditionRows
                    })
                  );

                  documentSections.push(new Paragraph({ text: "" }));


                  for (let lvIndex = 0; lvIndex < magneticBalanceLVs; lvIndex++) {
                    const lvNumber = lvIndex + 1;
                    const windingPrefix = lvNumber + 1;

                    documentSections.push(
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `Measured Current in LV${lvNumber} (V)`,
                            font: "Courier New",
                            bold: true,
                            size: 18
                          })
                        ]
                      })
                    );

                    const lvConditionRows = [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "HV CONDITION", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}U-${windingPrefix}V`, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}V-${windingPrefix}W`, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}W-${windingPrefix}U`, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          })
                        ]
                      })
                    ];

                    const lvData = magneticBalanceData.magneticBalanceData?.lv?.[testIndex] || {};
                    const baseOffset = lvIndex * 3;

                    hvConditions.forEach((condition) => {
                      const values = lvData[condition] || Array(12).fill('');
                      const cells = [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: condition, font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" }
                        })
                      ];


                      for (let i = 0; i < 3; i++) {
                        const valueIndex = baseOffset + i;
                        cells.push(
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(values[valueIndex] || ''), font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        );
                      }

                      lvConditionRows.push(
                        new TableRow({
                          children: cells
                        })
                      );
                    });

                    documentSections.push(
                      new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        rows: lvConditionRows
                      })
                    );

                    documentSections.push(new Paragraph({ text: "" }));
                  }
                }

                documentSections.push(new Paragraph({ text: "" }));


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "WINDING RESISTANCE MEASUREMENT",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "HV Winding Resistance",
                        font: "Courier New",
                        bold: true,
                        size: 20
                      })
                    ]
                  })
                );

                const hvWindingRows = [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Tap Position", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1U-1V", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1V-1W", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1W-1U", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" },
                        width: { size: 25, type: WidthType.PERCENTAGE }
                      })
                    ]
                  })
                ];

                const hvWindingData = magneticBalanceData.windingResistance?.hvWinding || [];
                const numberOfTapsForWinding = magneticBalanceData.numberOfTaps || hvWindingData.length || 1;

                for (let tapIndex = 0; tapIndex < numberOfTapsForWinding; tapIndex++) {
                  const row = hvWindingData[tapIndex] || Array(3).fill({ value: '', unit: 'mΩ' });
                  const cells = [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${tapIndex + 1}`, font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ];

                  for (let posIndex = 0; posIndex < 3; posIndex++) {
                    let value = '';
                    let unit = 'mΩ';

                    if (Array.isArray(row)) {
                      const item = row[posIndex];
                      if (typeof item === 'object' && item !== null) {
                        value = item.value || '';
                        unit = item.unit || 'mΩ';
                      } else {
                        value = item || '';
                      }
                    }

                    cells.push(
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(value)} ${unit}`, font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    );
                  }

                  hvWindingRows.push(
                    new TableRow({
                      children: cells
                    })
                  );
                }

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: hvWindingRows
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                const numberOfLVsForWinding = magneticBalanceData.numberOfLVs || 2;

                for (let lvNumber = 1; lvNumber <= numberOfLVsForWinding; lvNumber++) {
                  const lvKey = `lv${lvNumber}Winding`;
                  const windingPrefix = lvNumber + 1;

                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `LV${lvNumber} Winding Resistance`,
                          font: "Courier New",
                          bold: true,
                          size: 20
                        })
                      ]
                    })
                  );

                  const lvData = magneticBalanceData.windingResistance?.[lvKey] || [];

                  let lvValues = [];
                  let lvUnits = [];

                  if (Array.isArray(lvData)) {
                    lvData.forEach((item) => {
                      if (typeof item === 'object' && item !== null) {
                        lvValues.push(item.value || '');
                        lvUnits.push(item.unit || 'mΩ');
                      } else {
                        lvValues.push(item || '');
                        lvUnits.push('mΩ');
                      }
                    });
                  }


                  while (lvValues.length < 3) {
                    lvValues.push('');
                    lvUnits.push('mΩ');
                  }

                  documentSections.push(
                    new Table({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                      rows: [
                        new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}U-${windingPrefix}V`, font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: { fill: "a6a6a6" },
                              width: { size: 33, type: WidthType.PERCENTAGE }
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}V-${windingPrefix}W`, font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: { fill: "a6a6a6" },
                              width: { size: 33, type: WidthType.PERCENTAGE }
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${windingPrefix}W-${windingPrefix}U`, font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: { fill: "a6a6a6" },
                              width: { size: 34, type: WidthType.PERCENTAGE }
                            })
                          ]
                        }),
                        new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(lvValues[0])} ${lvUnits[0]}`, font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(lvValues[1])} ${lvUnits[1]}`, font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(lvValues[2])} ${lvUnits[2]}`, font: "Courier New" })] })],
                              borders: tableBorders
                            })
                          ]
                        })
                      ]
                    })
                  );

                  documentSections.push(new Paragraph({ text: "" }));
                }

                documentSections.push(new Paragraph({ text: "" }));


                const hasBushingData = () => {
                  const numberOfLVsForBushing = magneticBalanceData.numberOfLVs || 2;
                  const bushingData = magneticBalanceData.bushingData || [];

                  return bushingData.slice(0, numberOfLVsForBushing + 1).some(item =>
                    (item.irTest && item.irTest.trim() !== '') ||
                    (item.windingResistance && item.windingResistance.trim() !== '')
                  );
                };


                if (hasBushingData()) {
                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "BUSHING CT & WR MEASUREMENT",
                          font: "Courier New",
                          bold: true,
                          size: 24
                        })
                      ]
                    })
                  );

                  documentSections.push(new Paragraph({ text: "" }));

                  const bushingRows = [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Terminal", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "IR Test Secondary", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Winding Resistance Ω", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ];

                  const numberOfLVsForBushing = magneticBalanceData.numberOfLVs || 2;
                  const bushingData = magneticBalanceData.bushingData || [];

                  bushingData.slice(0, numberOfLVsForBushing + 1).forEach((item, index) => {
                    const description = index < numberOfLVsForBushing
                      ? `LV${index + 1} WT1 CT`
                      : "HV WT1 CT";

                    bushingRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: description, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.terminal || 'N/A'), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.irTest || 'N/A'), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.windingResistance || 'N/A'), font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  });

                  documentSections.push(
                    new Table({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                      rows: bushingRows
                    })
                  );

                  documentSections.push(new Paragraph({ text: "" }));
                }


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "INSULATION RESISTANCE",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                const insulationRows = [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Winding Ref", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1 Min", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10 Min", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Polarization Index", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      })
                    ]
                  })
                ];

                const insulationData = magneticBalanceData.insulationData || {};
                const numberOfLVsForInsulation = magneticBalanceData.numberOfLVs || 2;


                Object.entries(insulationData)
                  .filter(([key]) => {

                    if (key === "HV-E") return true;


                    if (key.startsWith("HV-LV")) {
                      const lvNum = parseInt(key.replace("HV-LV", ""));
                      return lvNum <= numberOfLVsForInsulation;
                    }


                    if (key.match(/^LV\d-E$/)) {
                      const lvNum = parseInt(key.replace("LV", "").replace("-E", ""));
                      return lvNum <= numberOfLVsForInsulation;
                    }


                    if (key.match(/^LV\d-LV\d$/)) {
                      const [lv1, lv2] = key.split("-").map(lv => parseInt(lv.replace("LV", "")));
                      return lv1 <= numberOfLVsForInsulation && lv2 <= numberOfLVsForInsulation;
                    }

                    return false;
                  })
                  .forEach(([key, data]) => {
                    insulationRows.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(key), font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(data.appliedVoltage ? `${data.appliedVoltage} V` : 'N/A'), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(data.min1 || '')} ${safeToString(data.min1Unit || '')}`, font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(data.min10 || '')} ${safeToString(data.min10Unit || '')}`, font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(data.pi || ''), font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      })
                    );
                  });

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: insulationRows
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                documentSections.push(new Paragraph({ text: "" }));



                const hasAnyTanDeltaData = () => {
                  if (!testBoxes || testBoxes.length === 0) return false;

                  return testBoxes.some(box => {
                    const isSelected = testFormData.selectedTests?.[box.id] || selectedTests[box.id];
                    const hasData = testFormData.inputValues?.[box.id] || inputValues[box.id];

                    if (!isSelected || !hasData) return false;

                    return hasData.some(row => row.some(cell => cell && cell.trim() !== ''));
                  });
                };

                const getTestDataForBox = (boxId) => {
                  const isSelected = testFormData.selectedTests?.[boxId] || selectedTests[boxId];
                  if (!isSelected) return null;

                  const data = testFormData.inputValues?.[boxId] || inputValues[boxId];
                  if (!data) return null;

                  const filteredData = data.filter(row => {
                    return row.some(cell => cell && cell.trim() !== '');
                  });

                  return filteredData.length > 0 ? filteredData : null;
                };

                if (hasAnyTanDeltaData()) {
                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "TANDELTA:",
                          font: "Courier New",
                          bold: true,
                          size: 24
                        })
                      ]
                    })
                  );

                  documentSections.push(new Paragraph({ text: "" }));

                  testBoxes.forEach(box => {
                    const testData = getTestDataForBox(box.id);

                    if (!testData) {
                      return;
                    }


                    const testLabel = box.label
                      ? `${box.label} - ${box.type}`
                      : `${box.id} - ${box.type}`;

                    documentSections.push(
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: testLabel,
                            font: "Courier New",
                            bold: true,
                            size: 18
                          })
                        ]
                      })
                    );

                    const testRows = [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Capacitance", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Current (mA)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Tan Delta", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: { fill: "a6a6a6" },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          })
                        ]
                      })
                    ];

                    testData.forEach((rowData) => {
                      testRows.push(
                        new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rowData[0] || 'N/A'), font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: { fill: "a6a6a6" }
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rowData[1] || 'N/A'), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rowData[2] || 'N/A'), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rowData[3] || 'N/A'), font: "Courier New" })] })],
                              borders: tableBorders
                            })
                          ]
                        })
                      );
                    });

                    documentSections.push(
                      new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        rows: testRows
                      })
                    );

                    documentSections.push(new Paragraph({ text: "" }));
                  });
                }

                documentSections.push(new Paragraph({ text: "" }));

                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "SURGE ARRESTER:",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                const connectionTypes = ['R-E', 'Y-E', 'B-E'];

                const surgeArresterValues = testFormData.surgeArresterValues || ['', '', ''];
                const surgeArresterUnits = testFormData.surgeArresterUnits || ['MΩ', 'MΩ', 'MΩ'];

                const surgeRows = [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Connection", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Value", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),

                    ]
                  })
                ];

                connectionTypes.forEach((conn, index) => {
                  surgeRows.push(
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(conn), font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(surgeArresterValues[index] || '')} ${safeToString(surgeArresterUnits[index] || 'MΩ')}`, font: "Courier New" })] })],
                          borders: tableBorders
                        }),

                      ]
                    })
                  );
                });

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: surgeRows
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));
                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "GENERAL INSPECTION Results:",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));

                const inspectionStatus = testFormData.inspectionStatus || {};
                const inspectionItems = {
                  visualInspection: 'Visual Inspection',
                  wiringChecking: 'Wiring Checking',
                  erectionChecking: 'Erection Checking',
                  wtiOtiChecking: 'WTI/OTI Checking',
                  breatherChecking: 'Breather Checking'
                };

                const inspectionRows = [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Check", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: {
                          fill: "a6a6a6"
                        },
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      })
                    ]
                  })
                ];

                Object.entries(inspectionItems).forEach(([key, label]) => {
                  inspectionRows.push(
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(label), font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(inspectionStatus[key] || 'N/A'), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    })
                  );
                });

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: inspectionRows
                  })
                );


                documentSections.push(new Paragraph({ text: "" }));
                documentSections.push(new Paragraph({ text: "" }));


                const convertInchesToTwip = (inches) => {
                  return Math.round(inches * 1440);
                };


                const footerTable = new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE, },
                  alignment: AlignmentType.LEFT,
                  rows: [
                    new TableRow({
                      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              spacing: { before: 0, after: 0 },
                              children: [
                                new TextRun({
                                  text: "Pie Power",
                                  font: "Courier New",
                                  bold: true,
                                  size: 18
                                })
                              ]
                            }),
                          ],
                          borders: tableBorders,
                          width: { size: 25, type: WidthType.PERCENTAGE },
                          verticalAlign: VerticalAlign.TOP,
                          margins: {
                            top: convertInchesToTwip(0.1),
                            bottom: convertInchesToTwip(0.25),
                            left: convertInchesToTwip(0.25),
                            right: convertInchesToTwip(0.25)
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              spacing: { before: 0, after: 0 },
                              children: [
                                new TextRun({
                                  text: "TPREL",
                                  font: "Courier New",
                                  bold: true,
                                  size: 18
                                })
                              ]
                            }),
                          ],
                          borders: tableBorders,
                          width: { size: 25, type: WidthType.PERCENTAGE },
                          verticalAlign: VerticalAlign.TOP,
                          margins: {
                            top: convertInchesToTwip(0.1),
                            bottom: convertInchesToTwip(0.25),
                            left: convertInchesToTwip(0.25),
                            right: convertInchesToTwip(0.25)
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              spacing: { before: 0, after: 0 },
                              children: [
                                new TextRun({
                                  text: "TPREL",
                                  font: "Courier New",
                                  bold: true,
                                  size: 18
                                })
                              ]
                            }),
                          ],
                          borders: tableBorders,
                          width: { size: 25, type: WidthType.PERCENTAGE },
                          verticalAlign: VerticalAlign.TOP,
                          margins: {
                            top: convertInchesToTwip(0.1),
                            bottom: convertInchesToTwip(0.25),
                            left: convertInchesToTwip(0.25),
                            right: convertInchesToTwip(0.25)
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              spacing: { before: 0, after: 0 },
                              children: [
                                new TextRun({
                                  text: "TPREL",
                                  font: "Courier New",
                                  bold: true,
                                  size: 18
                                }),
                                new SimpleField({
                                  instruction: "PAGE",
                                  children: [
                                    new TextRun({
                                      text: "1",
                                      font: "Courier New",
                                      size: 16
                                    })
                                  ]
                                }),
                                new SimpleField({
                                  instruction: "NUMPAGES",
                                  children: [
                                    new TextRun({
                                      text: "1",
                                      font: "Courier New",
                                      size: 16
                                    })
                                  ]
                                })
                              ]
                            }),
                          ],
                          borders: tableBorders,
                          width: { size: 25, type: WidthType.PERCENTAGE },
                          verticalAlign: VerticalAlign.TOP,
                          margins: {
                            top: convertInchesToTwip(0.1),
                            bottom: convertInchesToTwip(0.25),
                            left: convertInchesToTwip(0.25),
                            right: convertInchesToTwip(0.25)
                          }
                        })
                      ]
                    })
                  ]
                });





                const pageBorders = {
                  pageBorderTop: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },


                  pageBorderRight: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },
                  pageBorderBottom: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },
                  pageBorderLeft: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  }
                };

                const doc = new Document({
                  sections: [
                    {
                      properties: {
                        page: {
                          margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(1.0),
                            left: convertInchesToTwip(0.5)
                          },
                          borders: pageBorders,
                          pageNumbers: {
                            start: 1,
                            formatType: NumberFormat.DECIMAL
                          }
                        }
                      },
                      footers: {
                        default: new Footer({
                          children: [
                            footerTable,
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Page ",
                                  font: "Courier New",
                                  size: 16
                                }),
                                new TextRun({
                                  children: [PageNumber.CURRENT],
                                  font: "Courier New",
                                  size: 16
                                }),
                                new TextRun({
                                  text: " of ",
                                  font: "Courier New",
                                  size: 16
                                }),
                                new TextRun({
                                  children: [PageNumber.TOTAL_PAGES],
                                  font: "Courier New",
                                  size: 16
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                              spacing: {
                                before: 200
                              }
                            })
                          ]
                        })
                      },
                      headers: lightWatermarkBase64 ? {
                        default: new Header({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: lightWatermarkBase64,
                                  transformation: {
                                    width: 500,
                                    height: 500
                                  },
                                  floating: {
                                    horizontalPosition: {
                                      relative: HorizontalPositionRelativeFrom.PAGE,
                                      align: HorizontalPositionAlign.CENTER
                                    },
                                    verticalPosition: {
                                      relative: VerticalPositionRelativeFrom.PAGE,
                                      align: VerticalPositionAlign.CENTER
                                    },
                                    wrap: {
                                      type: TextWrappingType.BEHIND_TEXT
                                    },
                                    allowOverlap: true,
                                    behindDocument: true
                                  }
                                })
                              ]
                            })
                          ]
                        })
                      } : undefined,
                      children: documentSections
                    }
                  ]
                });



                Packer.toBlob(doc).then(blob => {
                  resolve(blob);
                }).catch(error => {

                  reject(error);
                });

              } catch (error) {

                reject(error);
              }
            };


            processVectorGroupImages();

          }).catch(error => {

            reject(error);
          });
        }).catch(error => {

          reject(error);
        });

      } catch (error) {

        reject(error);
      }
    });
  };




  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const loadFormDataSafely = (key, defaultValue = {}) => {
        try {
          const data = localStorage.getItem(key);
          return data ? JSON.parse(data) : defaultValue;
        } catch (error) {

          return defaultValue;
        }
      };

      const loadAllFormDataFromStorage = () => {
        return {
          transformerFormData: loadFormDataSafely('transformerFormData', {}),
          transformerVoltageExcitationData: loadFormDataSafely('transformerVoltageExcitationData', {}),
          transformerMagneticBalanceData: loadFormDataSafely('transformerMagneticBalanceData', {}),
          transformerElectricalTestData: loadFormDataSafely('transformerElectricalTestData', {}),
          transformerVectorGroupImages: loadFormDataSafely('transformerVectorGroupImages', {}),
          navbarData: loadFormDataSafely('navbarData', {}),
          createReportData: loadFormDataSafely('createReportData', {})
        };
      };

      const electricalTestData = {
        testBoxes,
        selectedTests,
        inputValues,
        inspectionStatus,
        surgeArresterValues,
        surgeArresterUnits
      };

      const savedGeneralData = JSON.parse(localStorage.getItem('transformerGeneralData') || '{}');
      const testData = JSON.parse(localStorage.getItem('transformerTestData') || '{}');

      const allFormData = {
        generalData: savedGeneralData?.formData || {},
        testData: testData || {},
        electricalTestData: electricalTestData
      };



      const wordBlob = await generateWordBlob(allFormData);
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      const reportNo = allFormData.generalData?.reportNo || allFormData.testData?.reportNo || formattedDate;
      const filename = `Transformer_Test_Report_${reportNo}.docx`;

      saveAs(wordBlob, filename);


      const cleared = clearAllData();

      if (cleared) {
        alert("Word document downloaded successfully. All form data has been cleared.");


        localStorage.setItem('shouldNavigateToReports', 'true');



      } else {
        alert("Word document downloaded, but there was an issue clearing some form data.");
      }

    } catch (error) {

      setErrorMessage(`Error generating Word document: ${error.message}`);
      alert(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };



  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };



  const handleManualClear = () => {
    if (window.confirm("Are you sure you want to clear all form data? This action cannot be undone.")) {
      const cleared = clearAllData();

      if (cleared) {
        alert("All form data has been cleared successfully, including the voltage excitation data section!");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        alert("There was an issue clearing some form data. Please check the console for details.");
      }
    }
  };

  if (showPreviousPage) {
    return <TransformerThree goBack={() => setShowPreviousPage(false)} />;
  }

  return (
    <div className="ct-3000">
      <span
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '20px',
          fontWeight: '600',
          color: '#333',
          cursor: 'pointer',
          marginLeft: '50px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>



      <div className="ct-3002">
        <div className="ct-3015">

          <div className="ct-3016">

            <div className="ct-3017">
              <h1 className="ct-3008">TANDELTA</h1>

              <div>
                <button
                  onClick={addTestBox}
                  disabled={isDataCleared}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#2c6d41',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: isDataCleared ? 'not-allowed' : 'pointer',
                    opacity: isDataCleared ? 0.5 : 1,
                    fontSize: '20px',
                    fontWeight: 'bold',

                  }}
                >
                  ADD ITEM
                </button>
              </div>
            </div>



            <div className="ct-3003">
              {testBoxes.map((test, index) => (
                <div key={test.id} className="ct-3018">
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '10px',
                    alignItems: 'center'
                  }}>
                    <input
                      type="text"
                      value={test.label}
                      onChange={(e) => updateTestBoxLabel(test.id, e.target.value)}
                      placeholder="Enter test name"
                      disabled={isDataCleared}
                      className="ct-3022"
                      style={{ flex: 1 }}
                    />
                    <select
                      value={test.type}
                      onChange={(e) => updateTestBoxType(test.id, e.target.value)}
                      disabled={isDataCleared}
                      className="ct-3022"
                      style={{ flex: 'none', width: '100px' }}
                    >
                      <option value="UST">UST</option>
                      <option value="GST">GST</option>
                      <option value="GSTg">GSTg</option>
                    </select>
                    {testBoxes.length > 1 && (
                      <button
                        onClick={() => removeTestBox(test.id)}
                        disabled={isDataCleared}
                        style={{
                          padding: '8px 12px',
                          backgroundColor: '#f44336',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: isDataCleared ? 'not-allowed' : 'pointer',
                          opacity: isDataCleared ? 0.5 : 1,
                          fontSize: '16px',
                          fontWeight: 'bold'
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>

                  <div
                    className={`ct-3019 ${selectedTests[test.id] ? 'ct-3020' : ''}`}
                    onClick={() => handleTestSelection(test.id)}
                    style={{
                      cursor: isDataCleared ? 'not-allowed' : 'pointer',
                      opacity: isDataCleared ? 0.5 : 1
                    }}
                  >
                    <div className="ct-3004">
                      {test.label || 'Click to configure'} - {test.type}
                    </div>
                  </div>

                  {selectedTests[test.id] && !isDataCleared && (
                    <div className="ct-3005">
                      <div className="ct-3006">
                        <div>APPLIED VOLTAGE</div>
                        <div>CAPACITANCE</div>
                        <div>I(mA)</div>
                        <div>Tan Delta</div>
                      </div>

                      {[0, 1, 2].map((row) => (
                        <div key={row} className="ct-3021">
                          <select
                            className="ct-3022"
                            value={getTestValues(test.id)[row][0]}
                            onChange={(e) => handleVoltageChange(test.id, row, e.target.value)}
                            disabled={isDataCleared}
                          >
                            <option value="">Select Voltage</option>
                            {voltageOptions.map((voltage) => (
                              <option key={voltage} value={voltage}>
                                {voltage}
                              </option>
                            ))}
                          </select>

                          {[1, 2, 3].map((col) => (
                            <input
                              key={col}
                              type="text"
                              className="ct-3022"
                              value={getTestValues(test.id)[row][col]}
                              onChange={(e) => handleInputChange(test.id, row, col, e.target.value)}
                              placeholder={
                                col === 1 ? "Capacitance" :
                                  col === 2 ? "Current" :
                                    col === 3 ? "Tan Delta" : ""
                              }
                              disabled={isDataCleared}
                            />
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>


          <div className="ct-3007">
            <div className="ct-3008">SURGE ARRESTER</div>

            <div className="ct-3009">
              {connectionTypes.map((conn, index) => (
                <div key={conn} className="ct-3023">
                  <div className="ct-3010">{conn}</div>
                  <div className="ct-3033">
                    <input
                      type="text"
                      className="ct-3034"
                      value={isDataCleared ? '' : surgeArresterValues[index]}
                      onChange={(e) => handleSurgeArresterChange(index, e.target.value)}
                      placeholder="Enter value"
                      disabled={isDataCleared}
                    />
                    <select
                      className="ct-3035"
                      value={isDataCleared ? 'MΩ' : surgeArresterUnits[index]}
                      onChange={(e) => handleSurgeArresterUnitChange(index, e.target.value)}
                      disabled={isDataCleared}
                    >
                      {resistanceUnits.map((unit) => (
                        <option key={unit} value={unit}>
                          {unit}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="ct-3011">
          <div className="ct-3012">
            <div className="ct-3013">GENERAL INSPECTION</div>
            <div className="ct-3014">
              {Object.entries({
                visualInspection: 'Visual Inspection',
                wiringChecking: 'Wiring Checking',
                erectionChecking: 'Erection Checking',
                wtiOtiChecking: 'WTI/OTI Checking',
                breatherChecking: 'Breather Checking'
              }).map(([key, label]) => (
                <div key={key} className="ct-3025">
                  <div className="ct-3026">{label}</div>
                  <select
                    className="ct-3027"
                    value={isDataCleared ? 'OK' : inspectionStatus[key]}
                    onChange={(e) => handleInspectionChange(key, e.target.value)}
                    disabled={isDataCleared}
                  >
                    <option value="OK">OK</option>
                    <option value="NOT OK">NOT OK</option>
                  </select>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="ct-3028">
        <button
          className="ct-3029"
          onClick={goBack}
          disabled={isLoading}
        >
          Back
        </button>
        <button
          className="ct-3029"
          onClick={handleSubmit}

          disabled={isLoading} >
          {isLoading ? "Processing..." : "Submit"}
        </button>

        {formSubmitted && (
          <button
            type="button"
            className="ct-3030"
            onClick={handleDownloadPDF}
            disabled={isLoading}
            style={{
              marginLeft: '10px',
              backgroundColor: '#4CAF50',
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
          >
            Download Word
          </button>
        )}
      </div>

    </div>
  );
}

function calculateErrorRange(voltageRatioData) {
  if (!voltageRatioData || voltageRatioData.length === 0) return "N/A";

  let minError = 100;
  let maxError = -100;

  voltageRatioData.forEach(tap => {
    if (tap.error !== undefined && tap.error !== null && !isNaN(tap.error)) {
      const error = parseFloat(tap.error);
      if (error < minError) minError = error;
      if (error > maxError) maxError = error;
    }
  });

  if (minError === 100 && maxError === -100) {
    return "N/A";
  }

  return `${minError.toFixed(2)}% to ${maxError.toFixed(2)}%`;
}

export default TransformerFour;



